import sortView from './sortView.html';
import './sortStyles.css';

export default function sortComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			sortBy: '=',
			sortName: '@',
			isDisabled: '<',
		},
		controllerAs: 'vm',
		controller: sortComponentCtrl,
		template: sortView,
		transclude: true,
	};
}

class sortComponentCtrl {
	sort() {
		if (this.isDisabled) {
			return;
		}
		if (this.sortBy == '-' + this.sortName || this.sortBy != this.sortName) {
			// sort ascending if we were descending with the same name
			// or or if we are sorting with a different name
			this.sortBy = this.sortName;
		} else {
			this.sortBy = '-' + this.sortName;
		}
	}
}
